import t from 'tcomb';
import Int from './Int';

const re_is_style_percentage = /(-)?\d+%/;
const Style_Percentage = t.subtype(t.Str, function(x) {
  return re_is_style_percentage.test(x);
});

const Style_Distance = t.union([Int, Style_Percentage]);

module.exports = Style_Distance;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Style_Distance.js
 **/